import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Redirect } from 'react-router'
import PropTypes from 'prop-types'
import { closeLoansNow } from '../../../../actions/homeowner'
import { selectHomeDigestLoading } from '../../../../store/selectors/display'
import { HomeownerDashboard } from '../../../../Components/homeowners/Dashboard/HomeownerDashboard'
import TextUpdatesCallout from '../../../../Components/shared/TextUpdatesCallout'
import { AppLayout } from '../../../../App/Layout/AppLayout'
import { SurveyPopup } from '../../../../Components/shared/SurveyPopup'
import { setActiveNavigationTab } from '../../../../store/slices/navigation'
import { NAVIGATION_TAB_NAMES } from '../../../../types/navigation'

const propTypes = {
  errorModal: PropTypes.oneOfType([PropTypes.element, PropTypes.func, PropTypes.node, PropTypes.bool]),
  notFound: PropTypes.bool,
  match: PropTypes.shape({
    path: PropTypes.string,
    url: PropTypes.string,
    isExact: PropTypes.bool,
    params: PropTypes.object
  })
}

const HomeownerDigest = ({ notFound, match }) => {
  const dispatch = useDispatch()

  const loading = useSelector(selectHomeDigestLoading)

  useEffect(() => {
    // Set the active navigation tab to Own.
    dispatch(setActiveNavigationTab(NAVIGATION_TAB_NAMES.HOMES))
    dispatch(closeLoansNow())
  }, [dispatch])

  return (
    <>
      <AppLayout loading={loading} match={match}>
        <HomeownerDashboard />
        <TextUpdatesCallout />
        <SurveyPopup />
      </AppLayout>
      {notFound && <Redirect to='/not-found' />}
    </>
  )
}

HomeownerDigest.propTypes = propTypes

export default HomeownerDigest
